<template>
  <div class="main-tab">
    <!-- Причина критичності -->
    <div v-if="ticket.reason" class="info-card reason-card">
      <div class="card-label">
        <i class="mdi mdi-alert-circle-outline"></i>
        <span>Причина критичності</span>
      </div>
      <div class="card-text" v-html="formatText(ticket.reason)"></div>
    </div>

    <!-- Опис тікету -->
    <div v-if="ticket.createComment" class="info-card description-card">
      <div class="card-label">
        <i class="mdi mdi-text-box-outline"></i>
        <span>Опис тікету</span>
      </div>
      <div class="card-text">
        <div v-html="formatText(ticket.createComment)"></div>

        <!-- Галерея зображень -->
        <div v-if="extractedImages.length > 0" class="images-gallery">
          <div
            v-for="(image, index) in extractedImages"
            :key="index"
            class="image-item"
            @click="openImageModal(index)"
          >
            <img :src="image" :alt="`Screenshot ${index + 1}`" />
            <div class="image-overlay">
              <i class="mdi mdi-magnify-plus-outline"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Рішення тікету -->
    <!-- <div v-if="ticket.decidedComment" class="info-card solution-card">
      <div class="card-label">
        <i class="mdi mdi-check-circle-outline"></i>
        <span>Рішення</span>
        <span v-if="ticket.decidedStatus" class="status-badge">{{ ticket.decidedStatus }}</span>
      </div>
      <div class="card-text">
        <div v-html="formatText(ticket.decidedComment)"></div>

        <div v-if="ticket.decidedDatetime || ticket.problemWas" class="solution-details">
          <div v-if="ticket.decidedDatetime" class="detail-item">
            <i class="mdi mdi-calendar-clock"></i>
            <span class="detail-label">Дата рішення:</span>
            <span class="detail-value">{{ ticket.decidedDatetime }}</span>
          </div>
          <div v-if="ticket.problemWas" class="detail-item">
            <i class="mdi mdi-history"></i>
            <span class="detail-label">Чи була проблема раніше:</span>
            <span class="detail-value">{{ ticket.problemWas }}</span>
          </div>
        </div>
      </div>
    </div> -->

    <!-- Якщо немає даних -->
    <div v-if="!ticket.reason && !ticket.createComment && !ticket.decidedComment" class="empty-state">
      <i class="mdi mdi-information-outline"></i>
      <p>Немає додаткової інформації</p>
    </div>

    <!-- Модалка для перегляду зображення на увесь екран -->
    <div v-if="showImageModal" class="image-modal" @click="closeImageModal">
      <div class="modal-backdrop"></div>
      <div class="modal-content">
        <button class="modal-close" @click="closeImageModal">
          <i class="mdi mdi-close"></i>
        </button>

        <button
          v-if="extractedImages.length > 1 && currentImageIndex > 0"
          class="modal-nav modal-prev"
          @click.stop="previousImage"
        >
          <i class="mdi mdi-chevron-left"></i>
        </button>

        <img
          :src="extractedImages[currentImageIndex]"
          :alt="`Screenshot ${currentImageIndex + 1}`"
          class="modal-image"
          @click.stop
        />

        <button
          v-if="
            extractedImages.length > 1 &&
            currentImageIndex < extractedImages.length - 1
          "
          class="modal-nav modal-next"
          @click.stop="nextImage"
        >
          <i class="mdi mdi-chevron-right"></i>
        </button>

        <div class="modal-counter">
          {{ currentImageIndex + 1 }} / {{ extractedImages.length }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainTab",
  props: {
    ticket: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showImageModal: false,
      currentImageIndex: 0,
    };
  },
  computed: {
    extractedImages() {
      if (!this.ticket.createComment) return [];

      const images = [];
      const text = this.ticket.createComment;

      // Шукаємо зображення у форматі <img src="...">
      const imgRegex = /<img[^>]+src="([^">]+)"/g;
      let match;
      while ((match = imgRegex.exec(text)) !== null) {
        images.push(match[1]);
      }

      // Шукаємо прямі посилання на зображення
      const imageUrlRegex =
        /(https?:\/\/[^\s]+\.(?:jpg|jpeg|png|gif|webp|bmp|svg))/gi;
      let urlMatch;
      while ((urlMatch = imageUrlRegex.exec(text)) !== null) {
        if (!images.includes(urlMatch[1])) {
          images.push(urlMatch[1]);
        }
      }

      return images;
    },
  },
  methods: {
    formatText(text) {
      if (!text) return "";

      let formatted = text;

      // Видаляємо теги <img> з тексту, бо вони будуть в галереї
      formatted = formatted.replace(/<img[^>]*>/g, "");

      // Видаляємо прямі посилання на зображення
      formatted = formatted.replace(
        /(https?:\/\/[^\s]+\.(?:jpg|jpeg|png|gif|webp|bmp|svg))/gi,
        ""
      );

      // Конвертуємо переноси рядків у <br>
      formatted = formatted.replace(/\n/g, "<br>");

      // Конвертуємо URL у посилання (які не є зображеннями)
      const urlRegex = /(https?:\/\/[^\s]+)/g;
      formatted = formatted.replace(urlRegex, (url) => {
        // Перевіряємо, чи це не зображення
        if (!/\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(url)) {
          return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
        }
        return "";
      });

      // Прибираємо зайві переноси рядків
      formatted = formatted.replace(/(<br\s*\/?>\s*){3,}/g, "<br><br>");

      return formatted;
    },
    openImageModal(index) {
      this.currentImageIndex = index;
      this.showImageModal = true;
      document.body.style.overflow = "hidden";

      // Додаємо слухач клавіатури
      window.addEventListener("keydown", this.handleKeyPress);
    },
    closeImageModal() {
      this.showImageModal = false;
      document.body.style.overflow = "";

      // Видаляємо слухач клавіатури
      window.removeEventListener("keydown", this.handleKeyPress);
    },
    previousImage() {
      if (this.currentImageIndex > 0) {
        this.currentImageIndex--;
      }
    },
    nextImage() {
      if (this.currentImageIndex < this.extractedImages.length - 1) {
        this.currentImageIndex++;
      }
    },
    handleKeyPress(e) {
      if (!this.showImageModal) return;

      switch (e.key) {
        case "Escape":
          this.closeImageModal();
          break;
        case "ArrowLeft":
          this.previousImage();
          break;
        case "ArrowRight":
          this.nextImage();
          break;
      }
    },
  },
  beforeUnmount() {
    // Очищаємо overflow та слухач при виході з компонента
    document.body.style.overflow = "";
    window.removeEventListener("keydown", this.handleKeyPress);
  },
};
</script>

<style scoped>
.main-tab {
  padding: 32px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.info-card {
  background: #ffffff;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 24px;
  transition: all 0.2s ease;
}

.info-card:hover {
  border-color: #e0e0e0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.card-label {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  color: #8e8e93;
  font-size: 13px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.card-label i {
  font-size: 16px;
}

.reason-card .card-label {
  color: #ff3b30;
}

.description-card .card-label {
  color: #007aff;
}

.solution-card .card-label {
  color: #34c759;
}

.card-label .status-badge {
  margin-left: auto;
  padding: 4px 12px;
  background: #e8f5e9;
  color: #34c759;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: none;
  letter-spacing: 0;
}

.card-text {
  font-size: 15px;
  line-height: 1.6;
  color: #1d1d1f;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

/* Деталі рішення */
.solution-details {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.detail-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #6c757d;
}

.detail-item i {
  font-size: 18px;
  color: #8e8e93;
  flex-shrink: 0;
}

.detail-label {
  font-weight: 500;
  color: #8e8e93;
}

.detail-value {
  color: #1d1d1f;
  font-weight: 400;
}

.card-text :deep(br) {
  display: block;
  content: "";
  margin: 8px 0;
}

.card-text :deep(a) {
  color: #007aff;
  text-decoration: none;
  transition: opacity 0.2s;
}

.card-text :deep(a):hover {
  opacity: 0.7;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 24px;
  color: #c7c7cc;
  text-align: center;
}

.empty-state i {
  font-size: 48px;
  margin-bottom: 12px;
  opacity: 0.6;
}

.empty-state p {
  margin: 0;
  font-size: 15px;
  font-weight: 400;
}

@media (max-width: 768px) {
  .main-tab {
    padding: 20px;
    gap: 16px;
  }

  .info-card {
    padding: 20px;
    border-radius: 10px;
  }

  .card-label {
    font-size: 12px;
    margin-bottom: 12px;
  }

  .card-text {
    font-size: 14px;
  }

  .empty-state {
    padding: 60px 20px;
  }
}

/* Галерея зображень */
.images-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px;
  margin-top: 20px;
}

.image-item {
  position: relative;
  aspect-ratio: 16/9;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  background: #f5f5f7;
  transition: transform 0.2s ease;
  box-shadow: 0 1px 12px rgba(0, 0, 0, 0.1);
}

.image-item:hover {
  transform: scale(1.02);
}

.image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s ease;
}

.image-item:hover .image-overlay {
  background: rgba(0, 0, 0, 0.3);
}

.image-overlay i {
  font-size: 32px;
  color: white;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.image-item:hover .image-overlay i {
  opacity: 1;
}

/* Модальне вікно */
.image-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-backdrop {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.95);
  backdrop-filter: blur(10px);
}

.modal-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-image {
  max-width: 100%;
  max-height: 90vh;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
}

.modal-close {
  position: fixed;
  top: 20px;
  right: 20px;
  width: 44px;
  height: 44px;
  border: none;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 50%;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  z-index: 10000;
}

.modal-close:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.1);
}

.modal-close i {
  font-size: 24px;
}

.modal-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 44px;
  height: 44px;
  border: none;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 50%;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  z-index: 10000;
}

.modal-nav:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-50%) scale(1.1);
}

.modal-nav i {
  font-size: 24px;
}

.modal-prev {
  left: 20px;
}

.modal-next {
  right: 20px;
}

.modal-counter {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  color: white;
  font-size: 14px;
  font-weight: 500;
  z-index: 10000;
}

@media (max-width: 768px) {
  .images-gallery {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 8px;
    margin-top: 16px;
  }

  .modal-close,
  .modal-nav {
    width: 40px;
    height: 40px;
  }

  .modal-close i,
  .modal-nav i {
    font-size: 20px;
  }

  .modal-close {
    top: 16px;
    right: 16px;
  }

  .modal-prev {
    left: 16px;
  }

  .modal-next {
    right: 16px;
  }

  .modal-counter {
    bottom: 16px;
    font-size: 13px;
  }
}

@media (prefers-color-scheme: dark) {
  /* .info-card {
    background: #1c1c1e;
    border-color: #38383a;
  }

  .info-card:hover {
    border-color: #48484a;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  }

  .card-text {
    color: #f5f5f7;
  }

  .empty-state {
    color: #636366;
  }

  .image-item {
    background: #2c2c2e;
  } */
}
</style>
